import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "layout", "direction"];
import clsx from "clsx";
import React from "react";
import { createMemoClass } from "../create-memo-class";
import { Image } from "..";
import { jsx as _jsx } from "react/jsx-runtime";
export var Card = props => {
  var {
    children,
    layout = "vertical",
    direction
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classes = useCardClass({
    layout,
    direction
  });
  return /*#__PURE__*/_jsx("div", _extends({
    className: classes
  }, rest, {
    children: children
  }));
};
var useCardClass = createMemoClass(props => {
  var layouts = {
    vertical: "card-vertical",
    horizontal: "card-horizontal",
    overlay: "card-overlay"
  };
  var directions = {
    reverse: "card-reverse"
  };
  var classes = clsx("card", layouts[props.layout], directions[props.direction]);
  return classes;
});

Card.Image = props => /*#__PURE__*/_jsx(Image, _extends({}, props, {
  className: "card-image"
}));

Card.Content = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "card-content",
    children: children
  });
};

Card.Actions = _ref2 => {
  var {
    children,
    style = {}
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: "card-actions",
    style: style,
    children: children
  });
};
//# sourceMappingURL=card.js.map